var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.943 1.25h.114c2.309 0 4.118 0 5.53.19 1.444.194 2.584.6 3.479 1.494s1.3 2.035 1.494 3.48c.19 1.411.19 3.22.19 5.529v.114c0 2.309 0 4.118-.19 5.53-.194 1.444-.6 2.584-1.494 3.479-.829.828-1.868 1.238-3.167 1.448-1.276.207-2.883.232-4.898.235a.75.75 0 1 1-.002-1.5c2.04-.003 3.523-.031 4.66-.216 1.117-.18 1.818-.5 2.346-1.028.57-.57.897-1.34 1.069-2.619.174-1.3.176-3.008.176-5.386s-.002-4.086-.176-5.386c-.172-1.279-.5-2.05-1.069-2.62-.57-.569-1.34-.896-2.619-1.068-1.3-.174-3.008-.176-5.386-.176s-4.087.002-5.387.176c-1.278.172-2.049.5-2.618 1.069-.529.528-.848 1.23-1.028 2.345-.185 1.138-.213 2.621-.217 4.661A.75.75 0 0 1 1.25 11c.004-2.016.03-3.622.236-4.898.21-1.3.62-2.338 1.448-3.167.895-.895 2.035-1.3 3.48-1.494 1.411-.19 3.22-.19 5.529-.19z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V8.81l-3.72 3.72a.75.75 0 1 1-1.06-1.06l3.72-3.72h-1.94A.75.75 0 0 1 12.5 7z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.948 13.25c-.898 0-1.648 0-2.242.08-.628.084-1.195.27-1.65.726-.456.455-.642 1.022-.726 1.65-.08.594-.08 1.344-.08 2.242v.104c0 .898 0 1.648.08 2.243.084.627.27 1.194.725 1.65.456.455 1.023.64 1.65.725.595.08 1.345.08 2.243.08h.104c.898 0 1.648 0 2.242-.08.628-.084 1.195-.27 1.65-.726.456-.455.642-1.022.726-1.65.08-.594.08-1.344.08-2.242v-.104c0-.898 0-1.648-.08-2.243-.084-.627-.27-1.194-.725-1.65-.456-.455-1.023-.64-1.65-.725-.595-.08-1.345-.08-2.243-.08zm-2.832 1.866c.13-.13.328-.237.79-.3.482-.064 1.13-.066 2.094-.066s1.612.002 2.095.067c.461.062.659.169.789.3.13.13.237.327.3.788.064.483.066 1.131.066 2.095s-.002 1.612-.067 2.095c-.062.461-.169.659-.3.789-.13.13-.327.237-.788.3-.483.064-1.131.066-2.095.066s-1.612-.002-2.095-.066c-.461-.063-.659-.17-.789-.3s-.237-.328-.3-.79c-.064-.482-.066-1.13-.066-2.094s.002-1.612.067-2.095c.062-.461.169-.659.3-.789z",
    clipRule: "evenodd",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.0f1e6059b536138f0604e5f359c7e2bf.svg";
export { ForwardRef as ReactComponent };